import { Observable } from "rxjs";
import { useWidgetStore } from "./index";

export const widgetStore$ = new Observable<
  ReturnType<typeof useWidgetStore.getState>
>((subscriber) => {
  // emit initial snapshot
  subscriber.next(useWidgetStore.getState());

  // emit future updates
  const unsub = useWidgetStore.subscribe((s) => subscriber.next(s));
  return () => unsub();
});
